module.exports = __webpack_public_path__ + "img/collection-engagementRingsHalo.76fef03.jpg";